import { useMutation, useQueryClient } from '@tanstack/react-query';
import { accountQueryKeys } from 'queries/account-query-keys';
import { userQueryKeys } from 'queries/user-query-keys';

const useInvalidateUserAndAccount = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () =>
            Promise.all([
                queryClient.invalidateQueries({
                    queryKey: userQueryKeys.current(),
                }),
                queryClient.invalidateQueries({
                    queryKey: accountQueryKeys.all(),
                }),
            ]),
    });
};

export { useInvalidateUserAndAccount };
